// extracted by mini-css-extract-plugin
export default {"priceInput":"Input_priceInput__FU61-"};